import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { sameDay } from '../lib/format';
import { mapProduct } from './productsService';

/**
 * Dashboard lazy: solo indicadores de hoy + listas limit(10).
 * No carga colecciones completas.
 */
export async function loadDashboard({ ruc }) {
  if (!ruc) throw new Error('RUC requerido');

  const [productosSnap, clientesSnap, boletasSnap, facturasSnap, cajasSnap] = await Promise.all([
    getDocs(query(collection(db, 'productos'), where('ruc', '==', ruc), where('activo', '==', true), limit(10))),
    getDocs(query(collection(db, 'clientes'), where('ruc', '==', ruc), limit(1))),
    getDocs(query(collection(db, 'boleta'), where('ruc', '==', ruc), orderBy('fechaEmision', 'desc'), limit(10))),
    getDocs(query(collection(db, 'factura'), where('ruc', '==', ruc), orderBy('fechaEmision', 'desc'), limit(10))),
    getDocs(query(collection(db, 'cajas'), where('ruc', '==', ruc), orderBy('fechaApertura', 'desc'), limit(5))),
  ]);

  const productos = productosSnap.docs.map(mapProduct);
  const boletas = boletasSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  const facturas = facturasSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  const cajas = cajasSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

  const hoy = new Date();
  const boletasHoy = boletas.filter((b) => sameDay(b.fechaEmision, hoy));
  const facturasHoy = facturas.filter((f) => sameDay(f.fechaEmision, hoy));
  const comprobantesHoy = [...boletasHoy, ...facturasHoy];
  const ventasHoy = comprobantesHoy.reduce((acc, c) => acc + Number(c.total || 0), 0);

  const stockBajo = productos.filter(
    (p) => p.controlaStock && Number(p.stock || 0) <= Number(p.stockMinimo || 0)
  ).length;

  const cajaAbierta = cajas.find((c) => c.estado === 'abierta') || null;
  const cajaHoy =
    cajaAbierta
      ? Number(cajaAbierta.montoInicial || 0)
      : cajas[0]
        ? Number(cajas[0].montoFinal || cajas[0].montoInicial || 0)
        : 0;

  const ultimosComprobantes = [...boletas, ...facturas]
    .sort((a, b) => new Date(b.fechaEmision || 0) - new Date(a.fechaEmision || 0))
    .slice(0, 10);

  return {
    ventasHoy,
    comprobantesHoy: comprobantesHoy.length,
    stockBajo,
    totalClientes: clientesSnap.size > 0 ? '1+' : '0',
    cajaHoy,
    ultimosComprobantes,
    productosStockBajo: stockBajo
      ? productos.filter((p) => p.controlaStock && Number(p.stock || 0) <= Number(p.stockMinimo || 0)).slice(0, 5)
      : [],
    productosRecientes: productos.slice(0, 5),
    readsEstimados: {
      productos: productosSnap.size,
      clientes: clientesSnap.size,
      boletas: boletasSnap.size,
      facturas: facturasSnap.size,
      cajas: cajasSnap.size,
    },
  };
}
